module.exports = __webpack_public_path__ + "static/media/duke_badge.91751678.svg";